import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { mockPartialShippingDetails, mockInvalidPartialShippingDetails } from '../../../mocks/address.js';
import formatGBP from '../../../utils/formatGBP.js';
import { fieldsetStyle } from '../styles.js';
var StubbedAddressActions = function StubbedAddressActions(_ref) {
  var onShippingAddressChange = _ref.onShippingAddressChange,
    selectedShippingOptionIdentifier = _ref.selectedShippingOptionIdentifier,
    setSelectedShippingOptionIdentifier = _ref.setSelectedShippingOptionIdentifier,
    setShippingAmount = _ref.setShippingAmount,
    _ref$shippingRates = _ref.shippingRates,
    shippingRates = _ref$shippingRates === void 0 ? [] : _ref$shippingRates;
  return jsxs(Fragment, {
    children: [jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed shipping action options"
      }), jsx("button", {
        onClick: function onClick() {
          return onShippingAddressChange({
            address: mockPartialShippingDetails,
            name: '',
            resolve: function resolve() {},
            reject: function reject() {}
          });
        },
        children: "Shipping Address Change"
      }), jsx("button", {
        onClick: function onClick() {
          return onShippingAddressChange({
            address: mockInvalidPartialShippingDetails,
            name: '',
            resolve: function resolve() {},
            reject: function reject() {}
          });
        },
        children: "Shipping Address Change (Failed)"
      })]
    }), shippingRates.length > 0 && jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed shipping rate options"
      }), Object.entries(shippingRates).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        var amount = value.amount,
          displayName = value.displayName,
          id = value.id;
        var isActive = selectedShippingOptionIdentifier === id;
        var onClickHandler = function onClickHandler() {
          setSelectedShippingOptionIdentifier === null || setSelectedShippingOptionIdentifier === void 0 || setSelectedShippingOptionIdentifier(id);
          setShippingAmount === null || setShippingAmount === void 0 || setShippingAmount(amount);
        };
        var formatedGBP = formatGBP(amount);
        return jsxs("button", {
          disabled: isActive,
          onClick: onClickHandler,
          children: [displayName, " (", formatedGBP, ")"]
        }, key);
      })]
    })]
  });
};
export { StubbedAddressActions as default };